import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPulsationDampener = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 50,
	height: 150,
	viewBox: "0 0 50.0 150.0",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M 0.0 20.0 A 25.0 20.0 0.0 1 1 50.0 20.0 L 50.0 110.0 A 25.0 20.0 0.0 1 1 0.0 110.0 Z M 25.0 130.0 L 25.0 150.0",
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1
	})
});
export default SvgPulsationDampener;
